module.exports = __webpack_public_path__ + "static/media/ic-togge-off.4718f2c2.svg";